export enum FILTER_NAME {
  ACCOMMODATION_BEACH = 'accommodationBeach',
  ACCOMMODATION_CHAIN = 'accommodationChains',
  ACCOMMODATION_DISTRICT = 'accommodationDistrict',
  ACCOMMODATION_STATION = 'accommodationStations',
  ACCOMMODATION_SKI_LIFT = 'accommodationSkiLift',
  BEACH_TYPE = 'beachType',
  BLUE_FLAG = 'blueFlag',
  BOOK_NOW_PAY_LATER = 'bookNowPayLater',
  CLIMATE = 'climate',
  DESTINATION_AIRPORT = 'destinationAirport',
  DIRECT_FLIGHT = 'directFlight',
  ENTERTAINMENT = 'entertainment',
  FACILITIES_GENERAL = 'facilitiesGeneral',
  FACILITIES_FAMILY = 'facilitiesFamily',
  FACILITIES_ACTIVITY = 'facilitiesActivity',
  FACILITIES_WELLNESS = 'facilitiesWellness',
  FACILITIES_FOOD = 'facilitiesFood',
  FACILITIES_GENERAL_GROUP = 'facilitiesGeneralGroup',
  FACILITIES_SERVICES = 'facilitiesServices',
  FACILITIES_FOOD_DRINK = 'facilitiesFoodDrink',
  FACILITIES_POOL_WELLNESS = 'facilitiesPoolWellness',
  FACILITIES_ACTIVITIES = 'facilitiesActivities',
  FACILITIES_OUTDOORS = 'facilitiesOutdoors',
  FACILITIES_INTERNET = 'facilitiesInternet',
  FACILITIES_PARKING = 'facilitiesParking',
  FACILITIES_TRANSPORT = 'facilitiesTransport',
  FACILITIES_ACCESSIBILITY = 'facilitiesAccessibility',
  FACILITIES_HEALTH_SAFETY = 'facilitiesHealthSafety',
  FACILITIES_SAFETY_SECURITY = 'facilitiesSafetySecurity',
  FACILITIES_KITCHEN = 'facilitiesKitchen',
  FACILITIES_SKI = 'facilitiesSki',
  FAUNA = 'fauna',
  FLASH_SALES = 'flashSales',
  FREE_CANCELLATION = 'freeCancellation',
  LEISURE_TYPE = 'leisureType',
  MEAL_PLAN = 'mealPlan',
  MY_PRICE = 'myPrice',
  OVERNIGHT_FLIGHTS = 'overnightFlights',
  PINK_PEOPLE = 'pinkPeople',
  PRICE_RANGE = 'priceRange',
  PROPERTY_NAME = 'propertyName',
  PROPERTY_STYLE = 'propertyStyle',
  PROPERTY_TYPE = 'propertyType',
  RATING = 'rating',
  STARS = 'stars',
  SUSTAINABILITY_CERTIFICATE = 'sustainabilityCertificate',
  TSH = 'tsh',
  WATER_SPORTS = 'waterSports',
  WATER_WAVES = 'waterWaves',
  SORT = 'sort', // TODO: is it correct here?
  SUSTAINABILITY = 'SUSTAINABILITY', // TODO: is it correct here?
  VIEW_MODE = 'VIEW_MODE', // TODO: is it correct here?
}

export enum CUSTOM_GROUP_NAME {
  SUSTAINABILITY = 'SUSTAINABILITY',
  BOOKING_OPTIONS = 'BOOKING_OPTIONS',
  DISCOUNT_OPTIONS = 'DISCOUNT_OPTIONS',
  FACILITIES = 'FACILITIES', // TODO: is it correct here?
  ALL_FILTERS = 'ALL_FILTERS', // TODO: is it correct here?
  SELECTED_FILTERS = 'SELECTED_FILTERS',
  RECENTLY_USED_FILTERS = 'RECENTLY_USED_FILTERS',
  POPULAR_FILTERS = 'POPULAR_FILTERS',
}

export enum OTHER_GROUP_NAME {}
